(function () {
  var D = window.PDP;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* buy box: priced on total box count, MoveOn and LiveOn mixed */
  var PRICE = { 1: 115, 2: 205, 3: 237, 4: 317, 6: 444, 12: 888 };
  var OFF = { 3: 22, 4: 22, 6: 55, 12: 110 };
  var EACH = { 1: 'S$115', 2: 'S$102.50', 3: 'S$79', 4: 'S$79.25', 6: 'S$74', 12: 'S$74' };
  var s = { n: 3, mo: 3, lo: 0 };
  /* 11.11 countdown: the sale ends at the end of 11 Nov, Singapore time */
  var D11_END = Date.UTC(2026, 10, 11, 16);
  function d11Tick() {
    var l = Math.max(0, D11_END - Date.now()), m = Math.floor(l / 6e4) % 60;
    var t = Math.floor(l / 864e5) + 'd ' + Math.floor(l / 36e5) % 24 + 'h ' + (m < 10 ? '0' : '') + m + 'm';
    $$('.cd-long').forEach(function (e) { e.textContent = t; });
  }
  d11Tick(); setInterval(d11Tick, 3e4);
  /* stock bar: PLACEHOLDER level for the mock-up. Before going live this must come from real inventory */
  var D11_SOLD = 82;
  $('#d11-stock').style.setProperty('--d11-sold', '0%');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es, o) {
      if (es[0].isIntersecting) { $('#d11-stock').style.setProperty('--d11-sold', D11_SOLD + '%'); o.disconnect(); }
    }).observe($('#d11-stock'));
  } else { $('#d11-stock').style.setProperty('--d11-sold', D11_SOLD + '%'); }
  function render() {
    $$('.opt').forEach(function (o) { o.setAttribute('aria-pressed', String(+o.dataset.n === s.n)); });
    $('#mo').textContent = s.mo; $('#lo').textContent = s.lo;
    $$('.step-n').forEach(function (e) {
      var k = e.dataset.k, o = k === 'mo' ? 'lo' : 'mo';
      $('[data-d="-1"]', e).disabled = s[k] === 0;
      $('[data-d="1"]', e).disabled = s[o] === 0;
    });
    var w = 115 * s.n, p = PRICE[s.n];
    $('#now').textContent = 'S$' + p;
    $('#d11-rib').textContent = OFF[s.n] ? '11.11 price: S$' + OFF[s.n] + ' off' : '11.11 prices start at 3 boxes';
    $('#was').innerHTML = w > p ? '<s>S$' + w + '</s>' : '';
    var label = s.n + (s.n > 1 ? ' boxes' : ' box'), days = s.n * 16;
    $('#o-n').textContent = label;
    $('#o-each').textContent = EACH[s.n] + ' a box';
    $('#o-save').textContent = w > p ? 'You save S$' + (w - p) : '';
    $('#o-save').hidden = w <= p;
    $('#o-days').textContent = days + ' days of joint care';
    $('#o-day').textContent = 'S$' + (p / days).toFixed(2) + ' a day';
    $$('.ocard__pic img').forEach(function (i) { i.classList.toggle('on', +i.dataset.n === s.n); });
    $('#st-now').textContent = 'S$' + p;
    $('#st-n').textContent = s.n + (s.n > 1 ? ' boxes' : ' box');
  }
  $$('.opt').forEach(function (o) {
    o.addEventListener('click', function () { s.n = +o.dataset.n; s.mo = s.n; s.lo = 0; render(); });
  });
  /* swipe the capsule or the photo to change offer */
  function offerList() { return $$('.opt').filter(function (o) { return o.offsetParent; }).map(function (o) { return +o.dataset.n; }).sort(function (a, b) { return a - b; }); }
  $$('#osw, #more, .ocard__pic').forEach(function (el) {
    var x0 = null, y0 = 0;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
      if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy)) return;
      var list = offerList(), i = list.indexOf(s.n) + (dx < 0 ? 1 : -1);
      if (i < 0 || i >= list.length) return;
      s.n = list[i]; s.mo = s.n; s.lo = 0; render();
    }, { passive: true });
  });
  $$('.step-n button').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.parentNode.dataset.k, o = k === 'mo' ? 'lo' : 'mo', d = +b.dataset.d;
      if (s[k] + d < 0 || s[o] - d < 0) return;
      s[k] += d; s[o] -= d; render();
    });
  });
  $('#tg').addEventListener('click', function () {
    var on = $('#more').classList.toggle('on');
    this.textContent = on ? 'Hide 2, 4 and 12 boxes offers' : 'See 2, 4 and 12 boxes offers';
    this.setAttribute('aria-expanded', String(on));
    if (!on && (s.n === 2 || s.n === 4 || s.n === 12)) { s.n = 3; s.mo = 3; s.lo = 0; render(); }
    if (on) $('.pick').scrollIntoView({ block: 'start' });
  });
  /* cart drawer: same box ladder as the store, priced on total boxes */
  var LADDER = { 1: 115, 2: 205, 3: 237, 4: 317, 5: 397, 6: 444, 7: 559, 8: 649, 9: 703, 10: 783, 11: 863, 12: 888 };
  var cart = { mo: 0, lo: 0 }, drawer = $('#cart'), cartTimer;
  var thumbs = { mo: $('#cart-thumb-mo'), lo: $('#cart-thumb-lo') };
  function boxes(n) { return n + (n > 1 ? ' boxes' : ' box'); }
  function cartLine(k, title, sub) {
    return '<div class="cart__it"><img src="' + thumbs[k].getAttribute('src') + '" alt="" width="58" height="58"><b>' + title + '</b><div>' + sub + '</div></div>';
  }
  function cartRender() {
    var n = cart.mo + cart.lo, html = '';
    if (cart.mo) html += cartLine('mo', 'MoveOn™ · ' + boxes(cart.mo), '<small>' + cart.mo * 16 + ' sachets · 25 ml each</small><small>One-time purchase · ' + cart.mo * 16 + '-day supply</small>');
    if (cart.lo) html += cartLine('lo', 'LiveOn™ · ' + boxes(cart.lo), '<small>20 ml sachets</small><small>One-time purchase</small>');
    $('#cart-lines').innerHTML = html;
    $('#cart-fill').hidden = !n; $('#cart-foot').hidden = !n; $('#cart-empty').hidden = !!n;
    $('#cart-n').hidden = !n; $('#cart-n').textContent = n;
    if (!n) return;
    var was = 115 * n, now = LADDER[n];
    $('#cart-was').textContent = was > now ? 'S$' + was : '';
    $('#cart-sub').textContent = 'S$' + now;
    var off = n >= 12 ? 110 : n >= 6 ? 55 : n >= 3 ? 22 : 0;
    $('#cart-11').textContent = off ? '11.11: S$' + off + ' off' : ''; $('#cart-11').hidden = !off;
    $('#cart-save').textContent = 'S$' + (was - now + 9.9).toFixed(2);
    $('#cart-total').textContent = 'S$' + now;
  }
  /* the checkout button must work again if someone comes back from checkout with the Back button */
  var cartAt = 0;
  function cartGoReady() { var g = $('#cart-go'); g.disabled = false; g.textContent = 'Continue to secure checkout'; }
  addEventListener('pageshow', cartGoReady);
  function cartOpen() {
    clearTimeout(cartTimer); cartRender(); cartAt = Date.now();
    cartGoReady();
    if (!drawer.open) drawer.showModal();
    var root = document.documentElement, bar = innerWidth - root.clientWidth;
    root.style.overflow = 'hidden'; root.style.paddingRight = bar ? bar + 'px' : '';
    drawer.offsetWidth; drawer.classList.add('on');
  }
  function cartClose() {
    drawer.classList.remove('on');
    document.documentElement.style.overflow = ''; document.documentElement.style.paddingRight = '';
    cartTimer = setTimeout(function () { drawer.close(); }, 300);
  }
  $$('[data-add]').forEach(function (b) {
    b.addEventListener('click', function () { cart.mo = s.mo; cart.lo = s.lo; cartOpen(); });
  });
  $('#cart-open').addEventListener('click', cartOpen);
  $('#cart-x').addEventListener('click', cartClose);
  drawer.addEventListener('cancel', function (e) { e.preventDefault(); cartClose(); });
  drawer.addEventListener('click', function (e) {
    /* a double tap on Add to cart must not close the drawer it just opened */
    if (e.target === drawer && Date.now() - cartAt > 600) cartClose();
  });
  $('#cart-go').addEventListener('click', function () {
    var shop = window.D11_SHOP;
    if (!shop) { this.textContent = 'Mockup: checkout not connected'; return; }
    /* single boxes only, so Shopify's box-price and 11.11 discounts can count them */
    var items = [];
    if (cart.mo) items.push({ id: shop.moveon, quantity: cart.mo });
    if (cart.lo) items.push({ id: shop.liveon, quantity: cart.lo });
    if (!items.length) return;
    var go = this; go.disabled = true; go.textContent = 'Going to secure checkout…';
    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body || {}) });
    }
    /* if Shopify refuses the cart request, the direct cart link still takes the customer to checkout with the same boxes */
    function direct() { location.href = '/cart/' + items.map(function (i) { return i.id + ':' + i.quantity; }).join(','); }
    post('/cart/clear.js')
      .then(function () { return post('/cart/add.js', { items: items }); })
      .then(function (r) {
        if (!r.ok) return direct();
        location.href = '/checkout';
      })
      .catch(direct);
  });
  render();

  /* comment strip: phones swipe natively, mouse users can drag */
  ['#rots', '#revs'].forEach(function (sel) {
    var strip = $(sel), drag = null;
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      drag = { x: e.clientX, left: strip.scrollLeft };
      strip.style.scrollSnapType = 'none';
      strip.setPointerCapture(e.pointerId);
    });
    strip.addEventListener('pointermove', function (e) {
      if (drag) strip.scrollLeft = drag.left - (e.clientX - drag.x);
    });
    ['pointerup', 'pointercancel'].forEach(function (n) {
      strip.addEventListener(n, function () {
        drag = null;
        strip.style.scrollSnapType = '';
      });
    });
  });

  /* comment screenshots loop without an end; any touch or drag pauses the glide for 5 s */
  function glide(box, cards, n) {
    var pos = 0, last = 0, wait = 0, seen = false;
    function period() { return cards[n].offsetLeft - cards[0].offsetLeft; }
    function wrap(x) { var p = period(); return x >= p ? x - p : x < 0 ? x + p : x; }
    box.addEventListener('scroll', function () {
      var x = box.scrollLeft, y = wrap(x);
      if (y !== x) { box.scrollLeft = y; pos = y; }
    }, { passive: true });
    if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }).observe(box);
    function hold() { wait = performance.now() + 5000; }
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (n) { box.addEventListener(n, hold, { passive: true }); });
    requestAnimationFrame(function tick(now) {
      var dt = Math.min(now - last, 60); last = now;
      if (seen && now > wait) {
        if (Math.abs(box.scrollLeft - pos) > 2) pos = box.scrollLeft;
        pos = wrap(pos + 22 * dt / 1000);
        box.scrollLeft = pos;
      }
      requestAnimationFrame(tick);
    });
  }
  glide($('#revs'), $('#revs').querySelector('.revrow').children, 5);
  var rots = $('#rots'), rotsN = rots.children.length;
  [].slice.call(rots.children).forEach(function (c) {
    var k = c.cloneNode(true);
    k.setAttribute('aria-hidden', 'true');
    k.querySelector('img').alt = '';
    rots.appendChild(k);
  });
  glide(rots, rots.children, rotsN);

  /* real customer reviews: see more, read more, helpful (your own tap only until the review app holds real counts) */
  var rcr = $$('.rcr__r'), rcrShown = 8, rcrList = $('#rcr-l'), rcrMore = $('#rcr-m'), rcrFetch = null, rcrAdded = false;
  /* speed: the other reviews live in their own file, fetched just before the section is seen */
  function rcrLoad() {
    return rcrFetch || (rcrFetch = fetch((window.D11_SHOP && window.D11_SHOP.reviews) || 'img/rcr-more.json').then(function (r) { return r.json(); }).catch(function () { rcrFetch = null; return null; }));
  }
  function rcrAll(done) {
    rcrLoad().then(function (list) {
      if (list && !rcrAdded) {
        var t = document.createElement('template');
        t.innerHTML = list.join('');
        rcrList.appendChild(t.content);
        rcr = $$('.rcr__r'); rcrAdded = true;
      }
      done();
    });
  }
  if ('IntersectionObserver' in window) {
    var rcrNear = new IntersectionObserver(function (es) {
      if (es[es.length - 1].isIntersecting) { rcrNear.disconnect(); rcrLoad(); }
    }, { rootMargin: '1500px' });
    rcrNear.observe(rcrList);
  }
  function rcrPaint() {
    rcr.forEach(function (r, i) { r.hidden = i >= rcrShown; });
    rcrMore.hidden = rcrAdded && rcr.length <= rcrShown;
  }
  rcrMore.addEventListener('click', function () { rcrAll(function () { rcrShown += 10; rcrPaint(); }); });
  $('#rcr-s').addEventListener('change', function () {
    var how = this.value;
    $('#rcr-sv').textContent = this.options[this.selectedIndex].text;
    rcrAll(function () {
      rcr.sort(function (a, b) { return how === 'new' ? b.dataset.ms - a.dataset.ms : a.dataset.rank - b.dataset.rank; });
      rcr.forEach(function (r) { rcrList.appendChild(r); });
      rcrShown = 8; rcrPaint();
    });
  });
  $('#rcr-l').addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    if (b.classList.contains('rcr__more')) { b.previousElementSibling.classList.add('is-open'); b.remove(); return; }
    var on = b.getAttribute('aria-pressed') === 'true';
    b.setAttribute('aria-pressed', String(!on));
    b.querySelector('.rcr__up').textContent = on ? '△' : '▲';
    var base = +b.closest('.rcr__r').dataset.v;
    b.querySelector('.rcr__n').textContent = on ? (base || '') : base + 1;
  });

  /* write a review: stays private until the review app is connected at launch */
  var rwForm = $('#rw-form'), rwOpen = $('#rw-open');
  rwOpen.addEventListener('click', function () {
    rwForm.hidden = !rwForm.hidden;
    rwOpen.setAttribute('aria-expanded', String(!rwForm.hidden));
    if (!rwForm.hidden) rwForm.querySelector('input').focus();
  });
  rwForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var err = $('#rw-err'), f = rwForm.elements;
    var msg = !f.stars.value ? 'Please choose a star rating.' :
      f.review.value.trim().length < 10 ? 'Please write a few words about your experience.' :
      !f.name.value.trim() ? 'Please enter your name.' :
      !f.email.validity.valid || !f.email.value ? 'Please enter a valid email.' : '';
    err.textContent = msg; err.hidden = !msg;
    if (msg) return;
    var ok = $('#rw-ok');
    ok.textContent = 'Thank you, ' + f.name.value.trim().split(' ')[0] + '. We have received your review.';
    ok.hidden = false; rwForm.hidden = true; rwOpen.hidden = true; rwForm.reset(); ok.focus();
  });

  /* 90-day timeline: the line fills and each stage lights up as it reaches the screen */
  (function () {
    var tl = $('.tl'), items = $$('.tl__i', tl), line = $('.tl__line', tl), fill = $('.tl__fill', tl);
    tl.classList.add('tl--js');
    function paint() {
      var top = tl.getBoundingClientRect().top, mark = innerHeight * 0.62;
      var len = items[items.length - 1].getBoundingClientRect().top - items[0].getBoundingClientRect().top;
      line.style.height = len + 'px';
      fill.style.height = Math.max(0, Math.min(len, mark - top - 15)) + 'px';
      items.forEach(function (it) { it.classList.toggle('on', it.getBoundingClientRect().top + 16 < mark); });
    }
    addEventListener('scroll', paint, { passive: true });
    addEventListener('resize', paint);
    paint();
  })();

  /* side-scrolling rows on desktop: a slim slider with arrows replaces the browser scrollbar */
  $$('.rail').forEach(function (rail) {
    var nav = document.createElement('div');
    nav.className = 'railnav';
    nav.innerHTML = '<div class="railnav__track"><div class="railnav__thumb"></div></div><button type="button" aria-label="Scroll back">←</button><button type="button" aria-label="Scroll forward">→</button>';
    rail.parentNode.insertBefore(nav, rail.nextSibling);
    var track = nav.firstChild, thumb = track.firstChild, btns = nav.querySelectorAll('button');
    function paint() {
      var end = rail.scrollWidth - rail.clientWidth;
      nav.hidden = end < 2;
      if (end < 2) return;
      var w = Math.max(16, track.clientWidth * rail.clientWidth / rail.scrollWidth);
      thumb.style.width = w + 'px';
      thumb.style.left = (track.clientWidth - w) * rail.scrollLeft / end + 'px';
      btns[0].disabled = rail.scrollLeft < 2;
      btns[1].disabled = rail.scrollLeft > end - 2;
    }
    function step(dir) {
      var card = rail.firstElementChild, gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      rail.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
    }
    btns[0].addEventListener('click', function () { step(-1); });
    btns[1].addEventListener('click', function () { step(1); });
    function moveTo(clientX, grabAt) {
      var r = track.getBoundingClientRect(), room = r.width - thumb.offsetWidth;
      var x = Math.max(0, Math.min(room, clientX - r.left - grabAt));
      rail.scrollLeft = room ? x / room * (rail.scrollWidth - rail.clientWidth) : 0;
    }
    var grab = null;
    track.addEventListener('pointerdown', function (e) {
      grab = e.target === thumb ? e.clientX - thumb.getBoundingClientRect().left : thumb.offsetWidth / 2;
      rail.style.scrollSnapType = 'none';
      track.setPointerCapture(e.pointerId);
      moveTo(e.clientX, grab);
    });
    track.addEventListener('pointermove', function (e) { if (grab !== null) moveTo(e.clientX, grab); });
    ['pointerup', 'pointercancel'].forEach(function (n) {
      track.addEventListener(n, function () { grab = null; rail.style.scrollSnapType = ''; });
    });
    rail.addEventListener('scroll', paint, { passive: true });
    addEventListener('resize', paint);
    addEventListener('load', paint);
    paint();
  });

  /* sticky bar and WhatsApp button */
  var stick = $('#stick'), wa = $('#wa');
  new IntersectionObserver(function (e) {
    var past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
    stick.classList.toggle('on', past);
    wa.classList.toggle('up', past);
  }).observe($('.buybox .btn'));

  /* menu */
  var mp = $('#menu-panel');
  $('#menu').addEventListener('click', function (e) { e.stopPropagation(); mp.hidden = !mp.hidden; });
  /* top menu: hides while scrolling down, comes back as soon as you scroll up */
  var topBar = $('.top'), topY = Math.max(0, scrollY);
  addEventListener('scroll', function () {
    var y = Math.max(0, scrollY), d = y - topY;
    if (Math.abs(d) < 6) return;
    topBar.classList.toggle('is-hid', d > 0 && y > 120 && mp.hidden);
    topY = y;
  }, { passive: true });
  document.addEventListener('click', function () { mp.hidden = true; });

  /* gallery: tap an image to see it full size */
  var zoom = $('#zoom'), zoomImg = zoom.querySelector('img'), zoomList = $$('#gal .tile > img'), zoomAt = 0;
  function zoomShow(i) {
    zoomAt = (i + zoomList.length) % zoomList.length;
    zoomImg.src = zoomList[zoomAt].src;
    zoomImg.alt = zoomList[zoomAt].alt;
  }
  function zoomClose() {
    zoom.close();
  }
  zoomList.forEach(function (im, i) {
    var tile = im.parentNode;
    tile.tabIndex = 0;
    tile.setAttribute('role', 'button');
    tile.setAttribute('aria-label', 'View image larger');
    function open() {
      zoomShow(i);
      zoom.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    tile.addEventListener('click', open);
    tile.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  });
  zoom.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
  zoom.addEventListener('click', function (e) { if (e.target === zoom) zoomClose(); });
  zoom.querySelector('.zoom__x').addEventListener('click', zoomClose);
  zoom.querySelector('.zoom__nav--p').addEventListener('click', function () { zoomShow(zoomAt - 1); });
  zoom.querySelector('.zoom__nav--n').addEventListener('click', function () { zoomShow(zoomAt + 1); });

  /* gallery: very slow auto scroll on phones, stops for 5 seconds after any interaction */
  var gal = $('#gal'), galPauseUntil = performance.now() + 2000, galIgnoreUntil = 0, galPos = 0, galLast = 0, galSeen = true;
  function galHold() {
    galPauseUntil = performance.now() + 5000;
    gal.style.scrollSnapType = '';
  }
  ['pointerdown', 'touchstart', 'wheel', 'keydown', 'click'].forEach(function (n) {
    gal.addEventListener(n, galHold, { passive: true });
  });
  gal.addEventListener('scroll', function () {
    var now = performance.now();
    if (now < galPauseUntil && now > galIgnoreUntil) galPauseUntil = now + 5000;
  }, { passive: true });
  zoom.addEventListener('close', galHold);
  new IntersectionObserver(function (es) { galSeen = es[0].isIntersecting; }).observe(gal);
  function galTick(now) {
    var dt = Math.min(now - galLast, 100), end = gal.scrollWidth - gal.clientWidth;
    galLast = now;
    if (end > 0 && galSeen && !zoom.open && now >= galPauseUntil) {
      gal.style.scrollSnapType = 'none';
      if (galPos >= end - 1) {
        galPauseUntil = galIgnoreUntil = now + 2500;
        galPos = 0;
        gal.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        galPos += 14 * dt / 1000;
        gal.scrollLeft = galPos;
      }
    } else if (now >= galIgnoreUntil) {
      galPos = gal.scrollLeft;
    }
    requestAnimationFrame(galTick);
  }
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) requestAnimationFrame(galTick);

  /* speed: content videos start downloading 1500px before they are seen, then loop while on screen */
  function lazyVideo(v, threshold) {
    var seen = false;
    function go() { if (seen) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
    v.addEventListener('canplay', go);
    if (!('IntersectionObserver' in window)) { v.preload = 'auto'; v.load(); seen = true; go(); return; }
    var near = new IntersectionObserver(function (es) {
      if (!es[es.length - 1].isIntersecting) return;
      near.disconnect(); v.preload = 'auto'; v.load();
    }, { rootMargin: '1500px' });
    near.observe(v);
    new IntersectionObserver(function (es) {
      seen = es[es.length - 1].isIntersecting;
      if (seen) go(); else v.pause();
    }, { threshold: threshold }).observe(v);
    /* iPhone Low Power Mode can refuse the first play, so retry on the first touch or scroll */
    ['touchstart', 'scroll'].forEach(function (e) { addEventListener(e, go, { passive: true, once: true }); });
  }
  lazyVideo($('.vidbox video'), .4);

  /* knee video: each label lights up with its part */
  var jv = $('#joint video'), pins = $$('#joint [data-from]');
  jv.defaultPlaybackRate = jv.playbackRate = 1.6;
  lazyVideo(jv, .25);
  function syncPins() {
    var t = jv.currentTime, all = t >= 10 && t < 11.3;
    pins.forEach(function (x) { x.classList.toggle('on', all || (t >= +x.dataset.from && t < +x.dataset.to)); });
  }
  ['timeupdate', 'seeked', 'pause', 'play'].forEach(function (e) { jv.addEventListener(e, syncPins); });
  (function tick() { syncPins(); requestAnimationFrame(tick); })();

  /* speed: pull lazy images in 1500px ahead, and load a whole carousel together because its off-screen cards never trigger on their own */
  function nearImages() {
    if (!('IntersectionObserver' in window)) return;
    var near = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        near.unobserve(e.target);
        (e.target.tagName === 'IMG' ? [e.target] : $$('img[loading="lazy"]', e.target)).forEach(function (i) { i.loading = 'eager'; });
      });
    }, { rootMargin: '1500px' }), boxes = [];
    $$('img[loading="lazy"]').forEach(function (i) {
      if (i.closest('dialog')) return;
      var b = i.closest('.gal, .rots, .rail, .ocard__pic, .sec--press') || i;
      if (boxes.indexOf(b) < 0) { boxes.push(b); near.observe(b); }
    });
  }
  var nearDone = false;
  function nearOnce() { if (!nearDone) { nearDone = true; nearImages(); } }
  addEventListener('load', nearOnce);
  addEventListener('scroll', nearOnce, { passive: true, once: true });
  setTimeout(nearOnce, 2500);

  /* Sandy's list: the pill nearest the middle of the screen glows */
  var whyList = $$('#why li');
  function lightPill() {
    var mid = innerHeight / 2, best = null, gap = Infinity;
    whyList.forEach(function (li) {
      var r = li.getBoundingClientRect(), d = Math.abs(r.top + r.height / 2 - mid);
      if (d < gap) { gap = d; best = li; }
    });
    var at = gap < mid ? whyList.indexOf(best) : -1;
    whyList.forEach(function (li, i) { li.classList.toggle('on', i === at); });
  }
  addEventListener('scroll', lightPill, { passive: true });
  addEventListener('resize', lightPill);
  lightPill();

  /* comparison */
  $$('[data-rvtab]').forEach(function (t) {
    t.addEventListener('click', function () {
      var i = t.dataset.rvtab;
      $$('[data-rvtab]').forEach(function (x) { x.classList.toggle('on', x === t); });
      $$('.c-rv').forEach(function (c) { c.hidden = c.dataset.rv !== i; });
      $('#rv-name').textContent = t.textContent;
    });
  });

  /* sheet: stories, experts, ingredient science, LiveOn */
  var sheet = $('#sheet'), body = $('#sheet-body');
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  function open(content) { body.innerHTML = content; sheet.showModal(); sheet.scrollTop = 0; }
  function close() { sheet.close(); }
  $('#sheet-x').addEventListener('click', close);
  sheet.addEventListener('click', function (e) { if (e.target === sheet) close(); });
  sheet.addEventListener('close', function () { if (!sheet.open) body.innerHTML = ''; });

  $$('[data-story]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = D.stories[+b.dataset.story];
      open('<video src="' + v.src + '" controls autoplay playsinline></video><h3>' + esc(v.name) + '</h3><p><b>' + esc(v.quote) + '</b></p>' +
        v.rest.slice(v.rest.findIndex(function (t) { return t.charAt(0) === '\u201c'; }) + 1).map(function (t) { return '<p>' + esc(t) + '</p>'; }).join(''));
    });
  });
  $$('[data-exp]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = D.experts[+b.dataset.exp];
      open('<h3>' + esc(v.name) + '</h3><p><b>' + esc(v.title) + '</b></p><p>' + esc(v.body) + '</p>');
    });
  });
  $$('[data-ing]').forEach(function (b) {
    b.addEventListener('click', function () {
      var i = +b.dataset.ing, c = D.science[i], n = D.ingredients[i].name;
      open('<h2>' + n + '</h2><p class="muted">' + esc(c.dose || '') + (c.dose && c.origin ? ' · ' : '') + esc(c.origin || '') + '</p>' +
        (c.claim ? '<p class="sci-claim">' + esc(c.claim) + '</p>' : '') +
        (c.sections || []).map(function (x) { return '<h3>' + esc(x[0]) + '</h3><p>' + x[1] + '</p>'; }).join(''));
    });
  });
  $('#lo-open').addEventListener('click', function () { open($('#lo-tpl').innerHTML); });

  /* LiveOn sheet: benefit filters, tick-box verdict, add or decline */
  var LO_BENEFITS = {"Sugar damage": ["Stops sugar sticking to your proteins in the first place", "Helps bring down A1C, your three-month blood sugar number", "Flattens the blood sugar spike after a meal", "Helps your body hold on to GLP-1, the fullness hormone", "Helps your gut release more GLP-1", "Helps your body respond to insulin properly again", "Helps lower fasting blood sugar", "Blocks sugar damage in skin, kidneys and blood vessels", "Clears the wear left behind when glucose oxidises", "Lowers fructosamine, the short-term sugar damage marker"], "Antioxidant defence": ["Puts back SOD, the antioxidant your body makes itself", "Lowers the standard lab markers of oxidative stress", "Tops up glutathione, your cells' main internal antioxidant", "Delivers CoQ10 for cell energy and defence", "Protects your DNA from oxidative damage", "Protects the membranes around your cells from going rancid", "Protects the mitochondria that make your energy", "Covers both kinds of antioxidant defence at once", "Slows the build-up of worn-out cells", "Packs a very high antioxidant score into one 20 ml sachet"], "Skin": ["Helps you build new collagen", "Blocks the enzymes that chew up collagen and elastin", "Stops sugar stiffening the collagen you already have", "Softens the look of wrinkles and fine lines", "Helps skin hold on to moisture", "Improves skin firmness and elasticity", "Helps skin keep its shape instead of sagging", "Protects skin from sun-driven ageing", "Evens out dark patches and uneven tone", "Helps skin cells regenerate", "Strengthens skin's own defences", "Calms redness and reactive skin", "Supports wound healing and repair"], "Heart and arteries": ["Lowers oxidised LDL, the harmful form of cholesterol", "Keeps the lining of your blood vessels healthy", "Supports healthy blood pressure", "Keeps blood from clotting more than it should", "Improves HDL and your overall cholesterol picture", "Keeps arteries springy instead of stiff", "Lowers the risk of plaque building up in arteries", "Improves circulation to hands, feet and skin", "Helps lower triglycerides", "Stops sugar damage collecting in your blood vessel walls"], "Brain": ["Supports memory and thinking", "Protects brain cells from oxidative damage", "Calms inflammation in the brain", "Supports brain recovery after a knock or injury", "Sharpens focus, clarity and how quickly you think", "Supports BDNF, the growth factor that keeps the brain adaptable", "Lowers the protein build-up linked to Alzheimer's risk", "Stops sugar damage collecting in brain cells", "Slows age-related decline in thinking", "Protects the barrier that shields your brain"], "Inflammation": ["Turns down NF-kB, the master switch for inflammation", "Lowers COX-2, one of the main inflammation pathways", "Lowers the inflammatory messengers in your blood", "Lowers CRP, the blood test doctors use for inflammation", "Eases joint inflammation and cartilage wear", "Calms inflammation in the gut lining", "Blocks the 5-LOX inflammation pathway", "Quiets the NLRP3 inflammasome", "Lowers the low-grade inflammation that builds with age", "Eases inflammation-driven aches"], "Longevity": ["Switches on SIRT1, your repair gene, 15x more than resveratrol", "Activates AMPK, your cells' energy regulator", "Supports autophagy, your cells' self-cleaning", "Limits worn-out cells that stop pulling their weight", "Supports NAD+ through SIRT1", "Protects telomeres, the caps on your DNA", "Blocks the AGE-RAGE cascade that drives tissue damage", "Keeps growth signalling in balance", "Supports healthy gene expression"], "Metabolism": ["Improves how your body handles fats", "Helps reduce fat stored around the organs", "Supports a healthier body composition", "Helps you build more and better mitochondria", "Lowers metabolic syndrome risk markers", "Supports fat burning"], "Eyes": ["Lowers macular degeneration risk", "Protects the retina from oxidative damage", "Protects the lens from the sugar damage behind cataracts", "Protects eyes from UV and blue light", "Supports sharp vision over the long run"], "Immunity": ["Supports your first-line immune defences", "Slows the immune decline that comes with age", "Supports natural killer cell activity", "Protects immune cells from oxidative stress", "Supports antiviral defences"], "Gut": ["Feeds a more diverse gut microbiome", "Tightens up a leaky gut lining", "Lowers oxidative stress in gut tissue", "Eases digestive discomfort", "Supports regularity"], "Liver": ["Supports both phases of liver detox", "Improves fatty liver markers", "Protects liver cells from oxidative damage"], "Kidneys, hair and nails": ["Protects kidney tissue from sugar damage", "Protects kidney cells from oxidative stress", "Supports stronger hair with less breakage", "Strengthens nails and reduces brittleness"]};
  var LO_VERDICT = [
    null,
    'Worth a look. MoveOn alone is still enough.',
    'LiveOn starts to make sense.',
    'LiveOn can do a lot for you.',
    'LiveOn is made for people like you.',
    'Worth adding LiveOn.',
    'You would feel it all over your body.',
    'If anyone needs LiveOn, it is you.'
  ];
  function loFilter(btn, cat) {
    var list = $('[data-lo-list]', body), key = cat || '*', same = !list.hidden && list.dataset.showing === key;
    $$('[data-lo-cat], [data-lo-all]', body).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    if (same) { list.hidden = true; list.removeAttribute('data-showing'); return; }
    list.innerHTML = (cat ? [cat] : Object.keys(LO_BENEFITS)).map(function (g) {
      return (cat ? '' : '<h5>' + g + '</h5>') + '<ul>' + LO_BENEFITS[g].map(function (t) { return '<li>' + t + '</li>'; }).join('') + '</ul>';
    }).join('');
    list.hidden = false; list.scrollTop = 0; list.dataset.showing = key;
    btn.setAttribute('aria-pressed', 'true');
  }
  body.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-lo-cat], [data-lo-all], [data-lo-add], [data-lo-decline]');
    if (!t) return;
    if (t.hasAttribute('data-lo-cat')) { loFilter(t, t.dataset.loCat); return; }
    if (t.hasAttribute('data-lo-all')) { loFilter(t, null); return; }
    if (t.hasAttribute('data-lo-add')) { if (s.lo === 0) { s.lo = 1; s.mo = s.n - 1; } }
    else { s.mo = s.n; s.lo = 0; }
    render(); close();
  });
  body.addEventListener('change', function (e) {
    if (!e.target.matches('[data-lo-check]')) return;
    var n = $$('[data-lo-check]', body).filter(function (i) { return i.checked; }).length;
    if ($('[data-lo-key]', body).checked) n = LO_VERDICT.length - 1;
    var out = $('[data-lo-verdict]', body);
    out.hidden = !n; out.textContent = LO_VERDICT[n] || '';
  });
})();

/* FAQ: show 5 questions, the rest behind one button */
(function () {
  var box = document.querySelector('.accs--cards');
  if (!box) return;
  var total = box.children.length;
  if (total <= 5) return;
  var more = 'See all ' + total + ' questions';
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'btn btn--2 faq-more';
  btn.textContent = more;
  btn.setAttribute('aria-expanded', 'false');
  box.classList.add('accs--more');
  box.after(btn);
  btn.addEventListener('click', function () {
    var open = box.classList.toggle('is-open');
    btn.textContent = open ? 'Show fewer questions' : more;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) box.scrollIntoView({ block: 'nearest' });
  });
})();
